<template>
  <div class="integration-schedule-editor">
    <div v-for="(day, dayIdx) in scheduleDays" :key="dayIdx" class="integration-schedule-editor__day" :class="{ 'integration-schedule-editor__day--closed': !day.open }">
      <div class="integration-schedule-editor__weekday checkbox">
        <input :id="platform + '-schedule-day-' + dayIdx" v-model="day.open" type="checkbox" :disabled="disabled">
        <label :for="platform + '-schedule-day-' + dayIdx">{{ $t('days.' + dayIdx) | capitalize }}</label>
      </div>
      <div class="integration-schedule-editor__periods">
        <span v-if="!day.open" class="integration-schedule-editor__closed">{{ $t('marketplace.closedDay') }}</span>
        <template v-else>
          <div v-for="(interval, intervalIdx) in day.intervals" :key="intervalIdx" class="integration-schedule-editor__interval">
            <el-time-select v-model="interval[openingKey]" :disabled="disabled" :placeholder="$t('menuLink.from')" :picker-options="pickerOptions" :aria-label="$t('days.' + dayIdx) + ' ' + $t('menuLink.from')" />
            <span aria-hidden="true">—</span>
            <el-select v-model="interval[closingKey]" :disabled="disabled" :placeholder="$t('menuLink.to')" :aria-label="$t('days.' + dayIdx) + ' ' + $t('menuLink.to')" filterable>
              <el-option v-for="time in endTimeOptions" :key="time" :label="time" :value="time" />
            </el-select>
            <button v-if="intervalIdx > 0" type="button" class="integration-schedule-editor__remove" :disabled="disabled" :aria-label="$t('general.delete')" @click="removeInterval(dayIdx, intervalIdx)"><i class="ti-close" aria-hidden="true"></i></button>
          </div>
          <button type="button" class="integration-schedule-editor__add" :disabled="disabled" @click="addInterval(dayIdx)"><i class="ti-plus" aria-hidden="true"></i> {{ $t('marketplace.addInterval') }}</button>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { TimeSelect, Select, Option } from 'element-ui'

export default {
  name: 'IntegrationScheduleEditor',
  components: { [TimeSelect.name]: TimeSelect, [Select.name]: Select, [Option.name]: Option },
  props: {
    formData: { type: Object, required: true },
    platform: { type: String, required: true },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return { pickerOptions: { start: '00:00', step: '00:15', end: '23:59' } }
  },
  computed: {
    openingKey () { return this.platform === 'bolt' ? 'start_at_minutes_from_midnight' : 'opening_time' },
    closingKey () { return this.platform === 'bolt' ? 'stop_at_minutes_from_midnight' : 'closing_time' },
    scheduleDays () { return this.formData.schedule || [] },
    endTimeOptions () {
      const times = []
      for (let minute = 0; minute < 1440; minute += 15) {
        times.push(String(Math.floor(minute / 60)).padStart(2, '0') + ':' + String(minute % 60).padStart(2, '0'))
      }
      times.push('23:59')
      return times
    }
  },
  methods: {
    addInterval (dayIdx) {
      if (this.disabled) return
      const day = this.scheduleDays[dayIdx]
      day.intervals.push({ [this.openingKey]: '10:00', [this.closingKey]: '22:00' })
    },
    removeInterval (dayIdx, intervalIdx) {
      if (this.disabled || intervalIdx === 0) return
      this.scheduleDays[dayIdx].intervals.splice(intervalIdx, 1)
    }
  }
}
</script>

<style scoped>
.integration-schedule-editor { border-top: 1px solid #edf0f7; }
.integration-schedule-editor__day { display: grid; grid-template-columns: 150px minmax(0, 1fr); gap: 16px; align-items: start; padding: 14px 0; border-bottom: 1px solid #edf0f7; }
.integration-schedule-editor__weekday { margin: 8px 0 0; }
.integration-schedule-editor__weekday label { margin: 0; }
.integration-schedule-editor__periods { display: flex; flex-wrap: wrap; align-items: center; gap: 10px 16px; }
.integration-schedule-editor__interval { display: inline-flex; align-items: center; gap: 10px; }
.integration-schedule-editor__interval >>> .el-date-editor, .integration-schedule-editor__interval >>> .el-select { width: 120px; }
.integration-schedule-editor__add, .integration-schedule-editor__remove { border: 0; background: transparent; padding: 9px 5px; font-size: 12px; color: #674bd2; }
.integration-schedule-editor__remove { color: #d34b52; }
.integration-schedule-editor__add:disabled, .integration-schedule-editor__remove:disabled { opacity: .5; cursor: not-allowed; }
.integration-schedule-editor__closed { color: #8893a9; font-size: 13px; padding-top: 8px; }
@media (max-width: 600px) { .integration-schedule-editor__day { grid-template-columns: minmax(0, 1fr); gap: 6px; } }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Integrations/IntegrationScheduleEditor.vue